import envConfig from '@ey/voltron-config';

class Env extends Object {
	/**
	 * Returns the current environment's server URL, appended with
	 * whatever path is passed in as an argument, or just the root
	 * serverURL if path is undefined.
	 * Notice that I'm requiring that all paths be preceeded by a "/"
	 * character. This is because you want any request to the API
	 * root to look like "/", instead of "".
	 * @param {String} path - Path to be appended to the server URL
	 * @return {String} complete path string
	 */
	static getServerUrl(path = '') {
		return `${envConfig.url.serviceUrl}${path}`;
	}

	static getWebUrl(path = '') {
		return `${envConfig.url.oversight_web}/${path}`;
	}

	static getUniversalUrl(path = '') {
		return `${envConfig.url.universal_web}${path}`;
	}

	static getDocServiceUrl(path = '') {
		let url = envConfig.url.Engg_Doc_Url;

		if (url.endsWith('/')) {
			url = url.slice(0, -1);
		}

		if (path) {
			url += `/${path}`;
		}

		return url;
	}

	static getURL(urlName) {
		return envConfig.url[urlName];
	}

	static getInstrumentationKey() {
		return envConfig.ApplicationInsightsConfiguration.instrumentationkey;
	}

	/**
	 * Gets the base url for Hercules API calls.
	 * @param {string} urlName - urlName
	 * @param {number} engagementId - engagementId
	 * @return {String} the base URL, with the engagementId included in the url.
	 */
	static getBaseURL(urlName, engagementId) {
		let apiUrl = this.getURL(urlName);

		if (!apiUrl.endsWith('/')) {
			apiUrl += '/';
		}

		if (engagementId) {
			apiUrl = `${apiUrl}Engagements/${engagementId}/`;
		}

		return apiUrl;
	}

	static getOversightBaseURL(urlName, projectId) {
		let apiUrl = this.getURL(urlName);

		if (!apiUrl.endsWith('/')) {
			apiUrl += '/';
		}

		if (projectId) {
			apiUrl = `${apiUrl}Projects/${projectId}/`;
		}

		return apiUrl;
	}

	/**
	 * Get the Language from the package.json file
	 * @return {String} the language defined in the package file
	 */
	static getLanguage() {
		return envConfig.language;
	}

	/**
	 * Gets the correct error message to be displayed
	 * @param {Object} error - the error
	 * @returns {String} the correct message
	 * */
	static getErrorMessage(error) {
		if (error.response) {
			if (error.response.data === '') {
				return error.response.statusText;
			} else if (error.response.data.errorMessage) {
				return error.response.data.errorMessage;
			}
		} else if (error.message && error.message !== '') {
			return error.message;
		} else {
			return error.response.message;
		}
	}
	static allowDrydocks() {
		// Don't mind this expression.
		// It's just trying to work for string values in paas.json
		// and/or boolean values in development.json
		return envConfig.enableDrydocks === 'true' || envConfig.enableDrydocks === true;
	}

	static isDevEnviorment() {
		const envs = ['localhost', 'dev1', 'dev2'];
		const envUrl = this.getServerUrl();
		let itIs = false;
		envs.forEach((item) => {
			if (envUrl.includes(item)) itIs = true;
		});
		return itIs;
	}
}

export default Env;
